<template>
        <section class="side-margin min-height">
          <input type="checkbox" class="popup__checkbox" id="popup-checkbox" unchecked>
          <div class="popup">
              <div class="popup__container" id="popup-container">
                  <span class="popup__title" id="popup-title"></span>
                  <p class="popup__message" id="popup-message">Checking your transaction</p>
                    <div class="loader-icon loader-icon--primary" id="popup-loading"></div>
              </div>
          </div>

          <div class="row">
            <div class="col-2-of-4 market-table__container">
              <div class="table__header-container">
                <div class="table__header table__header--primary">buy deals</div>
              </div>
              <div class="filters">
                <label class="filters__dropdown-label" for="buy_filters-dropdown">Options</label>
                <input class="filters__checkbox--dropdown" type="checkbox" name="buy_dropdown" id="buy_filters-dropdown" checked>
                <label class="filters__clear-label" onclick="document.getElementById('buy_market-table-body').innerHTML = ''">Clear</label>

                <div class="filters__container">
                  <div class="filters__row">
                    <div class="filters__group" title="preferred currency when buying">
                      <label class="filters__img-label" for="buy_currency-credits">
                        <input class="filters__checkbox--img" type="radio" name="buy_currency" value="credits" id="buy_currency-credits">
                        <img  class="filters__circle filters__circle--primary" src="../assets/credit_small.png">
                      </label>
                      <label class="filters__img-label" for="buy_currency-dec">
                        <input class="filters__checkbox--img" type="radio" name="buy_currency" value="dec" id="buy_currency-dec" checked>
                        <img  class="filters__circle filters__circle--primary" src="../assets/dec_small.png">
                      </label>
                    </div> <!-- Filters group currency -->
                  </div> <!-- Filters row currency -->

                  <div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__label" for="buy_sound-alert">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_sound-alert" id="buy_sound-alert">
                        <div class="filters__dot filters__circle--primary"></div>
                        SOUND ALERT
                      </label>
                    </div>
                  </div> <!-- Filters row sound alert -->

                  <div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__label" for="buy_filter-change">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_change" id="buy_filter-change" usecase="filter">
                        <div class="filters__dot filters__circle--primary"></div>
                        MIN CHANGE [%]
                      </label>
                      <div class="filters__usecase" onclick="document.getElementById('buy_filter-change').checked = true">
                        <input class="filters__number" type="number" id="buy_filter-change-min">
                      </div>
                    </div>
                    <div class="filters__group">
                      <label class="filters__label" for="buy_filter-price">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_price" id="buy_filter-price">
                        <div class="filters__dot filters__circle--primary"></div>
                        PRICE RANGE [$]
                      </label>
                      <div class="filters__usecase" onclick="document.getElementById('buy_filter-price').checked = true">
                        <input class="filters__number" type="number" placeholder="min" id="buy_filter-price-min">
                        <input class="filters__number" type="number" placeholder="max" id="buy_filter-price-max">
                      </div>
                    </div>
                  </div> <!-- Filters row prices -->

                  <!--div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__img-label" for="buy_league-bronze" title="Bronze league">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_league" value="bronze" id="buy_league-bronze" unchecked>
                        <img  class="filters__circle filters__circle--primary" src="../assets/bronze.png">
                      </label>
                      <label class="filters__img-label" for="buy_league-silver" title="Silver league">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_league" value="silver" id="buy_league-silver" unchecked>
                        <img class="filters__circle filters__circle--primary" src="../assets/silver.png">
                      </label>
                      <label class="filters__img-label" for="buy_league-gold" title="Gold leauge">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_league" value="gold" id="buy_league-gold" unchecked>
                        <img class="filters__circle filters__circle--primary" src="../assets/gold.png">
                      </label>
                      <label class="filters__img-label" for="buy_league-diamond" title="Diamond leauge">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_league" value="diamond" id="buy_league-diamond" unchecked>
                        <img class="filters__circle filters__circle--primary" src="../assets/diamond.png">
                      </label>
                      <label class="filters__img-label" for="buy_league-champion" title="Champion leauge">
                        <input class="filters__checkbox--img" type="checkbox" name="buy_league" value="champion" id="buy_league-champion" unchecked>
                        <img class="filters__circle filters__circle--primary" src="../assets/champion.png">
                      </label>
                    </div--> <!-- Filters group leagues -->
                  <!--/div--> <!-- Filters row leagues -->

                    <div class="filters__row">
                      <div class="filters__group">
                        <label class="filters__img-label" for="buy_foil-standard">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_foil" value="standard" id="buy_foil-standard" unchecked>
                          <img  class="filters__circle filters__circle--primary" src="../assets/foil_standard.png">
                        </label>
                        <label class="filters__img-label" for="buy_foil-gold">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_foil" value="gold" id="buy_foil-gold" unchecked>
                          <img  class="filters__circle filters__circle--primary" src="../assets/foil_gold.png">
                        </label>
                      </div> <!-- Filters group foil -->
                      <div class="filters__group">
                        <label class="filters__img-label" for="buy_edition-alpha">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="alpha" id="buy_edition-alpha" unchecked>
                          <img  class="filters__circle filters__circle--primary" src="../assets/alpha.png">
                        </label>
                        <label class="filters__img-label" for="buy_edition-beta">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="beta" id="buy_edition-beta" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/beta.png">
                        </label>
                        <label class="filters__img-label" for="buy_edition-promo">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="promo" id="buy_edition-promo" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/promo.png">
                        </label>
                        <label class="filters__img-label" for="buy_edition-reward">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="reward" id="buy_edition-reward" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/reward.png">
                        </label>
                        <label class="filters__img-label" for="buy_edition-untamed">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="untamed" id="buy_edition-untamed" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/untamed.png">
                        </label>
                        <label class="filters__img-label" for="buy_edition-dice">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="dice" id="buy_edition-dice" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/dice.png">
                        </label>
                        <!--label class="filters__img-label" for="buy_edition-chaos">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_edition" value="chaos" id="buy_edition-chaos" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/chaos.png">
                        </label-->
                      </div> <!-- Filters group edition -->
                      <div class="filters__group">
                        <label class="filters__img-label" for="buy_common">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_rarity" value="common" id="buy_common" unchecked>
                          <img  class="filters__circle filters__circle--primary" src="../assets/common.png">
                        </label>
                        <label class="filters__img-label" for="buy_rare">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_rarity" value="rare" id="buy_rare" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/rare.png">
                        </label>
                        <label class="filters__img-label" for="buy_epic">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_rarity" value="epic" id="buy_epic" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/epic.png">
                        </label>
                        <label class="filters__img-label" for="buy_legendary">
                          <input class="filters__checkbox--img" type="checkbox" name="buy_rarity" value="legendary" id="buy_legendary" unchecked>
                          <img class="filters__circle filters__circle--primary" src="../assets/legendary.png">
                        </label>
                      </div> <!-- Filters group rarity -->
                    </div> <!-- Filters row cards -->
                </div> <!-- Filters container -->
              </div> <!-- Filters -->
              <table class="market-table" id="watchlist_buy">
                <thead class="market-table__head market-table__head--primary">
                  <tr class="market-table__header">
                    <th class="text-left">Card</th>
                    <th></th>
                    <th class="vanish"></th>
                    <th class="vanish"></th>
                    <th>BCX</th>
                    <th id="buy_head_USD">Price $</th>
                    <th class="vanish">Next</th>
                    <th id="buy_head_change">Change</th>
                  </tr>
                </thead>
                <tbody class="market-table__body market-table__body--primary" id="buy_market-table-body">
                  <!-- Table content here -->
                  <!--tr data-hash="id=232&amp;gold=false&amp;edition=3" data-market="7d34918be5a1f6d72aee49304eee890fcba73e41-0" onclick="table_click(this)" class="floating-card--trigger"><td class="floating-card--trigger">Wave Runasner<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/reward/Wave%20Runner_lv1.png"></div></td><td><img src="img/foil_standard.png" class="market-table__icon"></td><td><img src="img/reward.png" class="market-table__icon"></td><td class="vanish"><img src="img/common.png" class="market-table__icon"></td><td>0.57$</td><td class="vanish">0.573$</td><td>-1.00%</td></tr><tr data-hash="id=283&amp;gold=false&amp;edition=3" data-market="8998439bd4d213970bb162df82c240c2d87b654a-0" onclick="table_click(this)" class="floating-card--trigger"><td class="floating-card--trigger">Chain Spinner<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/reward/Chain%20Spinner_lv1.png"></div></td><td><img src="img/foil_standard.png"></td><td><img src="img/reward.png"></td><td class="vanish"><img src="img/common.png"></td><td>0.194$</td><td class="vanish">0.199$</td><td>-3.00%</td></tr><tr data-hash="id=285&amp;gold=false&amp;edition=3" data-market="5f7015a4c6d0210cef7a6601dd5e828e4c65fa7c-0" onclick="table_click(this)" class="floating-card--trigger"><td class="floating-card--trigger">Nightmare<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/reward/Nightmare_lv1.png"></div></td><td><img src="img/foil_standard.png"></td><td><img src="img/reward.png"></td><td class="vanish"><img src="img/common.png"></td><td>0.26$</td><td class="vanish">0.29$</td><td>-10.00%</td></tr-->
                </tbody>
              </table>

              <div class="loader-container">
                <div class="loader-text">Looking for deals</div>
                <div class="loader-icon loader-icon--primary"></div>
              </div>
            </div> <!-- col-2-of-4 -->

            <div class="col-2-of-4 market-table__container">
              <div class="table__header-container">
                <div class="table__header table__header--secondary">
                  rent deals
                </div>
              </div>
              <div class="filters">
                <label class="filters__dropdown-label" for="rent_filters-dropdown">Options</label>
                <input class="filters__checkbox--dropdown" type="checkbox" name="rent_dropdown" id="rent_filters-dropdown" checked>
                <label class="filters__clear-label" onclick="document.getElementById('rent_market-table-body').innerHTML = ''">Clear</label>

                <div class="filters__container">
                  <div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__img-label" for="rent_currency-credits" title="preferred currency when renting">
                        <input class="filters__checkbox--img" type="radio" name="rent_currency" value="rent_credits" id="rent_currency-credits">
                        <img  class="filters__circle filters__circle--secondary" src="../assets/credit_small.png">
                      </label>
                      <label class="filters__img-label" for="rent_currency-dec" title="preferred currency when renting">
                        <input class="filters__checkbox--img" type="radio" name="rent_currency" value="dec" id="rent_currency-dec" checked>
                        <img  class="filters__circle filters__circle--secondary" src="../assets/dec_small.png">
                      </label>

                        <label class="filters__align-text" id="rent_days_label">
                          RENT FOR
                        <input class="filters__number" type="number" placeholder="DAYS" value="7" id="rent_days">
                          DAYS
                        </label>

                    </div> <!-- Filters group currency -->
                  </div> <!-- Filters row currency -->

                  <div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__label" for="rent_sound-alert">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_sound-alert" id="rent_sound-alert">
                        <div class="filters__dot filters__circle--secondary"></div>
                        SOUND ALERT
                      </label>
                    </div>
                  </div> <!-- Filters row sound alert -->

                  <div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__label" for="rent_filter-change">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_change" id="rent_filter-change">
                        <div class="filters__dot filters__circle--secondary"></div>
                        MIN CHANGE [%]
                      </label>
                      <div class="filters__usecase" onclick="document.getElementById('rent_filter-change').checked = true">
                        <input class="filters__number" type="number" id="rent_filter-change-min" data-ref="#rent_filter-change">
                      </div>
                    </div>
                    <div class="filters__group">
                      <label class="filters__label" for="rent_filter-price">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_price" id="rent_filter-price">
                        <div class="filters__dot filters__circle--secondary"></div>
                        PRICE RANGE [$]
                      </label>
                      <div class="filters__usecase" onclick="document.getElementById('rent_filter-price').checked = true">
                        <input class="filters__number" type="number" placeholder="min" id="rent_filter-price-min">
                        <input class="filters__number" type="number" placeholder="max" id="rent_filter-price-max">
                      </div>
                    </div>
                  </div> <!-- Filters row prices -->

                  <!--div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__img-label" for="rent_league-bronze" title="Bronze league">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_league" value="bronze" id="rent_league-bronze" unchecked>
                        <img  class="filters__circle filters__circle--secondary" src="../assets/bronze.png">
                      </label>
                      <label class="filters__img-label" for="rent_league-silver" title="Silver league">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_league" value="silver" id="rent_league-silver" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/silver.png">
                      </label>
                      <label class="filters__img-label" for="rent_league-gold" title="Gold leauge">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_league" value="gold" id="rent_league-gold" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/gold.png">
                      </label>
                      <label class="filters__img-label" for="rent_league-diamond" title="Diamond leauge">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_league" value="diamond" id="rent_league-diamond" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/diamond.png">
                      </label>
                      <label class="filters__img-label" for="rent_league-champion" title="Champion leauge">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_league" value="champion" id="rent_league-champion" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/champion.png">
                      </label>
                    </div--> <!-- Filters group leagues -->
                  <!--/div--> <!-- Filters row leagues -->

                  <div class="filters__row">
                    <div class="filters__group">
                      <label class="filters__img-label" for="rent_foil-standard">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_foil" value="standard" id="rent_foil-standard" unchecked>
                        <img  class="filters__circle filters__circle--secondary" src="../assets/foil_standard.png">
                      </label>
                      <label class="filters__img-label" for="rent_foil-gold">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_foil" value="gold" id="rent_foil-gold" unchecked>
                        <img  class="filters__circle filters__circle--secondary" src="../assets/foil_gold.png">
                      </label>
                    </div> <!-- Filters group foil -->
                    <div class="filters__group">
                      <label class="filters__img-label" for="rent_edition-alpha">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_edition" value="alpha" id="rent_edition-alpha" unchecked>
                        <img  class="filters__circle filters__circle--secondary" src="../assets/alpha.png">
                      </label>
                      <label class="filters__img-label" for="rent_edition-beta">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_edition" value="beta" id="rent_edition-beta" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/beta.png">
                      </label>
                      <label class="filters__img-label" for="rent_edition-promo">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_edition" value="promo" id="rent_edition-promo" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/promo.png">
                      </label>
                      <label class="filters__img-label" for="rent_edition-reward">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_edition" value="reward" id="rent_edition-reward" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/reward.png">
                      </label>
                      <label class="filters__img-label" for="rent_edition-untamed">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_edition" value="untamed" id="rent_edition-untamed" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/untamed.png">
                      </label>
                      <label class="filters__img-label" for="rent_edition-dice">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_edition" value="dice" id="rent_edition-dice" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/dice.png">
                      </label>
                      <!--label class="filters__img-label" for="edition-chaos">
                        <input class="filters__checkbox--img" type="checkbox" name="edition" value="chaos" id="edition-chaos" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/chaos.png">
                      </label-->
                    </div> <!-- Filters group edition -->
                    <div class="filters__group">
                      <label class="filters__img-label" for="rent_common">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_rarity" value="common" id="rent_common" unchecked>
                        <img  class="filters__circle filters__circle--secondary" src="../assets/common.png">
                      </label>
                      <label class="filters__img-label" for="rent_rare">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_rarity" value="rare" id="rent_rare" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/rare.png">
                      </label>
                      <label class="filters__img-label" for="rent_epic">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_rarity" value="epic" id="rent_epic" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/epic.png">
                      </label>
                      <label class="filters__img-label" for="rent_legendary">
                        <input class="filters__checkbox--img" type="checkbox" name="rent_rarity" value="legendary" id="rent_legendary" unchecked>
                        <img class="filters__circle filters__circle--secondary" src="../assets/legendary.png">
                      </label>
                    </div> <!-- Filters group rarity -->
                  </div> <!-- Filters row cards -->
                </div> <!-- Filters container -->
              </div> <!-- Filters -->
              <table class="market-table" id="watchlist_rent">
                <thead class="market-table__head market-table__head--secondary">
                  <tr class="market-table__header">
                    <th class="text-left">Card</th>
                    <th></th>
                    <th class="vanish"></th>
                    <th class="vanish"></th>
                    <th>BCX</th>
                    <th id="rent_head_pow">Power</th>
                    <th id="rent_head_USD">Price $</th>
                    <th class="vanish">DEC</th>
                    <th class="vanish">Change</th>
                  </tr>
                </thead>
                <tbody class="market-table__body market-table__body--secondary" id="rent_market-table-body">
                  <!-- Table content here -->
                  <!--tr data-hash="id=232&amp;gold=false&amp;edition=3" data-market="7d34918be5a1f6d72aee49304eee890fcba73e41-0" onclick="table_click(this)" class="floating-card--trigger"><td class="floating-card--trigger">Wave Runasdfkdfknfkner<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/reward/Wave%20Runner_lv1.png"></div></td><td><img src="img/foil_standard.png"></td><td><img src="img/reward.png"></td><td class="vanish"><img src="img/common.png"></td><td>0.57$</td><td class="vanish">0.573$</td><td>-1.00%</td></tr><tr data-hash="id=283&amp;gold=false&amp;edition=3" data-market="8998439bd4d213970bb162df82c240c2d87b654a-0" onclick="table_click(this)" class="floating-card--trigger"><td class="floating-card--trigger">Chain Spinner<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/reward/Chain%20Spinner_lv1.png"></div></td><td><img src="img/foil_standard.png"></td><td><img src="img/reward.png"></td><td class="vanish"><img src="img/common.png"></td><td>0.194$</td><td class="vanish">0.199$</td><td>-3.00%</td></tr><tr data-hash="id=285&amp;gold=false&amp;edition=3" data-market="5f7015a4c6d0210cef7a6601dd5e828e4c65fa7c-0" onclick="table_click(this)" class="floating-card--trigger"><td class="floating-card--trigger">Nightmare<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/reward/Nightmare_lv1.png"></div></td><td><img src="img/foil_standard.png"></td><td><img src="img/reward.png"></td><td class="vanish"><img src="img/common.png"></td><td>0.26$</td><td class="vanish">0.29$</td><td>-10.00%</td></tr-->
                </tbody>
              </table>

              <div class="loader-container">
                <div class="loader-text">Looking for deals</div>
                <div class="loader-icon loader-icon--secondary"></div>
              </div>
            </div> <!-- col-2-of-4 -->
          </div>
        </section>
</template>

<script>
import { set_store, on_load_tables, on_unload_tables } from '../js/lib.js'

window.addEventListener("beforeunload", function (e) {
    on_unload_tables();
});

/*window.addEventListener('unhandledrejection', event => {
    event.preventDefault();
    // You can use `event.reason` here for the rejection reason, and
    // `event.promise` for the promise that was rejected
    console.log(`Suppressed the rejection '${event.reason.message}'`);
});

Promise.reject(new Error("Something went wrong"));*/

export default {
  name: 'Tables',
  beforeCreate() {
    set_store(this.$store);
    //start_stream();
  },
  mounted() {
    on_load_tables()
   },
  methods: {  }
}
</script>